export default __webpack_public_path__ + "static/media/T240_CoC.714db5ac.pdf";